import { ITask } from '@modules/TasksModule/types';
import { InboxContext } from '../types';
import { inboxActions, inboxState } from '../state';
import { isBookingRetentionEnabled } from '../lib/isBookingRetentionEnabled';
import SoftPhoneModule from '@modules/SoftPhoneModule';
import { setCallToRejected } from '../callHandlers/callStateHandler';
import TasksModule from '@modules/TasksModule';

function handleTaskReject(context: InboxContext, task: ITask): void {
  // Retention on, the previous selection is the card the CSR was on before the
  // call rang (REQ-CTL-BOOK-006 AC-4 (h)). If that card has gone since (a
  // transfer, say), go home rather than select a card that is not there.
  const previousTaskId = inboxState.previousSelectedTaskId;
  if (
    isBookingRetentionEnabled() &&
    previousTaskId &&
    !TasksModule.getTask(previousTaskId)
  ) {
    inboxActions.clearPreviousSelectedTaskId(previousTaskId);
  }
  inboxActions.restorePrevSelectedTaskId();

  setCallToRejected({ context, taskId: task.id, eventType: 'task-reject' });

  if (TasksModule.getTask(task.id)) {
    TasksModule.setTaskAttribute(task.id, 'isAnswering', true);
  }
  SoftPhoneModule.callControl.cancel(task.attributes.callId);
}

export default handleTaskReject;
